/**
 * Hash map with
 * the icons classes
 */
(function () {
  let gExports;
  let gModule;

  // NOTE (alevy): On update actuator icon, the key used
  // on AxisParam must be used here
  /* Module export glue */
  /* global define */
  gExports = {
    add: 'icon-plus',
    remove: 'icon-minus',
    add_application: 'icon-add-application',
    add_sequence: 'icon-add-sequence',
    reconnect: 'icon-redo',
    play: 'icon-play',
    debug: 'icon-run-debug',
    download: 'icon-arrowdown',
    upload: 'icon-arrow-up',
    pause: 'icon-pause',
    step: 'icon-skip-play',
    stop: 'icon-stop',
    scrollLeft: 'icon-backward',
    scrollRight: 'icon-forward',
    configuration: 'icon-cogs',
    library: 'icon-launch-sequence-editor',
    sequence: 'icon-sequence',
    childSequence: 'icon-child-sequence',
    breakpoint: 'icon-stop-circle',
    motor: 'icon-motor',
    define: 'icon-cog',
    waitFor: 'icon-time',
    input: 'icon-arrow-to-the-right',
    add_input: 'icon-add-input',
    output: 'icon-arrow-from-left',
    add_output: 'icon-add-output',
    inputOutput: 'icon-input-output',
    trigger: 'icon-trigger',
    loop: 'icon-redo',
    condition: 'icon-condition',
    log: 'icon-start-chat flip-y',
    locked: 'icon-lock',
    unknown: 'icon-help',
    lookAt: 'icon-make-opaque',
    axis: 'icon-belt-actuator',
    axis_alternate: 'icon-axis',
    axis_add: 'icon-axis-add',
    beltActuator: 'icon-belt-actuator',
    ballScrew: 'icon-ballscrew',
    conveyor: 'icon-conveyor',
    rackAndPinion: 'icon-rack-andpinion',
    pneumatic: 'icon-pneumatic',
    electricCylinder: 'icon-electric-actuator',
    indexer: 'icon-rotary-indexer',
    indexer_v2: 'icon-rotary-indexer',
    swap: 'icon-swap',
    error: 'icon-help',
    plusCircle: 'fas fa-plus-circle',
    minusCircle: 'fas fa-minus-circle',
    appParameter: 'icon-parameter',
    removeCard: 'far fa-trash-alt',
    addMotor: 'icon-motor-add',
    addWait: 'icon-add-wait',
    addOutput: 'icon-add-output',
    addExecution: 'icon-add-execution',
    addPlus: 'icon-add-plus',
    addLog: 'icon-add-message',
    removeCircle: 'icon-remove',
    plusRaw: 'fal fa-plus',
    conditionNew: 'icon-condition-new',
    addCondition: 'icon-add-condition',
    addVariable: 'icon-add-variable',
    addLoop: 'icon-add-loop',
    setVariable: 'icon-variable',
    setInputVariable: 'icon-variable-input',
    loopNew: 'icon-loop',
    edit: "icon-edit",
    caretUp: "fas fa-caret-up",
    caretDown: "fas fa-caret-down",
    bell: "fal fa-bell",
    chevronDown: "fas fa-chevron-down",
    chevronUp: "fas fa-chevron-up",
    importExport: 'icon-import-export',
    exclamationCircle: 'fal fa-exclamation-circle',
    infoCircle: 'fal fa-info-circle',
    uiBuilder: 'icon-ui-builder',
    uiBuilderSingle: 'icon-single-ui',
    uiResizeIcon: 'icon-drag-expand',
    robot: 'icon-robot-assets',
    addRobot: 'icon-add-robot',
    addRobotSequence: 'icon-add-robot-sequence',
    uiDragIcon: 'icon-drag',
    controller: 'icon-controller',
    connectedController: 'icon-connected-controller',
    unavailable: 'icon-ban',
    danger: 'icon-danger',
    checkmark: 'icon-check-mark',
    close: 'icon-close',
    fsm: 'icon-state-machine',
    addFsm: 'icon-add-state-machine',
    copy: 'icon-paste',
    back: 'icon-back',
    functions: 'icon-functions',
    functionIndividual: 'icon-function-individual',
    variableIndividual: 'icon-variable-individual',
  },

  gModule = typeof module;
  if (gModule !== 'undefined' && module.exports != undefined) {
    module.exports = gExports;
  } else if (define != undefined && typeof define === 'function' && define.amd) {
    define([], function () { return gExports; });
  }
}());
